import { useState, useRef, useEffect } from "react";
import "./ProductFilterDropDown.scss";
import { useTranslation } from "react-i18next";

export const ProductFilterDropdown = ({
  selectedValue,
  onUpdateValue,
  allValues,
  side = "left",
}) => {
  const { t } = useTranslation("productModule");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    onUpdateValue(value);
    setIsOpen(false);
  };

  return (
    <div className="product-filter-dropdown-container" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="product-filter-button"
      >
        <h4 className="product-filter-button-text">
          {selectedValue === "All-Categories" || selectedValue === "All-Brands"
            ? t(selectedValue)
            : selectedValue}
        </h4>
        <svg
          className={`product-filter-button-arrow ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <ul className={`product-filter-dropdown ${side}`}>
          {allValues.map((value) => (
            <li
              key={value}
              onClick={() => handleSelect(value)}
              className={`product-filter-item ${
                value === selectedValue ? "highlighted" : ""
              }`}
            >
              {value === "All-Categories" || value === "All-Brands"
                ? t(value)
                : value}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
